// useUtilisateurs.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import UtilisateurService from "@/integrations/service/utilisateur.service";

export const useUtilisateurs = () => {
  return useQuery({
    queryKey: queryKeys.utilisateurs,
    queryFn: UtilisateurService.getAll,
  });
};

export const useBloquerUtilisateur = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UtilisateurService.bloquer,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.utilisateurs }),
  });
};

export const useDebloquerUtilisateur = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UtilisateurService.debloquer,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.utilisateurs }),
  });
};

export const useLeverVerrouTemporaire = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UtilisateurService.leverVerrouTemporaire,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.utilisateurs }),
  });
};

export const useSupprimerUtilisateur = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UtilisateurService.supprimer,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.utilisateurs }),
  });
};
